import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import education from "../images/MML-Education-Image.jpg";

function Mentorship() {
  return (
    <>
      <Container
        fluid
        className="bg-dark"
        style={{
          color: "whitesmoke",
          fontFamily: "CustomFont",
          minHeight: "80vh",
        }}
      >
        <Row>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <h4
              className="App-heading-text-color"
              style={{
                paddingTop: "20px",
                paddingBottom: "20px",
                textAlign: "center",
                paddingLeft: "10vw",
                paddingRight: "10vw",
              }}
            >
              Professional Mentorship Program
            </h4>
          </Col>
        </Row>
        <Row>
          <Col
            className="text-left"
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            Welcome to the Muscle Mechanics Lab Professional Mentorship Program
            with Dr. Gerard McMahon, the next step in driving the evolution of
            your career.
          </Col>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <img src={education} style={{ maxWidth: "80vw" }} alt="education" />
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            <h5 className="App-heading-text-color">
              Why does the mentorship exist & what will I get from it?
            </h5>
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            The mentorship exists to accelerate the progression of the
            mentee&apos;s professional development, to enhance all aspects of
            their career. Just like MML training programs, each mentee&apos;s
            mentorship program is 100% unique and is tailored to their
            development needs. The program will develop the following in each of
            the mentees;
            <br />
            - Theoretical knowledge
            <br />
            - Technical knowledge
            <br />
            - Technical skills
            <br />
            - Critical Analysis & Scientific Approach
            <br />
            - Confidence building
            <br />
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            <h5 className="App-heading-text-color">
              What is the structure of the Professional Mentorship Program?
            </h5>
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            The program is 12 months in duration and includes the following
            aspects; aspects; <br />
            - 1:1 Online mentoring session each month <br />
            - Exclusive Online learning materials & Toolkits <br />
            - Tailored scientific literature for your individual needs <br />
            - Retention of all of these for free
            <br />
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            <h5 className="App-heading-text-color">
              What is included in the content of the Program?
            </h5>
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            Content of the program includes some of the following... and more;
            <br />
            - Career S.W.O.T. Analysis <br />
            - Physiology of resistance training <br />
            - Program Design <br />
            - Biomechanics of resistance training <br />
            - Physiology of Recovery <br />
            - Nutrition for Physique Development <br />
            - Development of Scientific Principles <br />
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            <h5 className="App-heading-text-color">
              Why the Muscle Mechanics Lab Professional Mentorship Program?
            </h5>
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            Dr. Gerard McMahon is a recognised world-leader in the science &
            application of muscular development. With his Ph.D. entitled “The
            Physiological & Biomechanical Basis of Muscular Hypertrophy”, Dr.
            McMahon developed one of the most successful resistance training
            techniques for muscle hypertrophy - partial range-of-motion at
            optimal muscle lengths. Dr. McMahon has published extensively in
            resistance training physiology & biomechanics, works with industry
            leaders on this topic & gives talks all over the world. In essence,
            he is a verified industry leader at the very forefront of muscle
            science.
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            <h5 className="App-heading-text-color">
              Who is eligible for the MML Professional Mentorship Program?
            </h5>
          </Col>
        </Row>
        <Row>
          <Col
            style={{
              paddingLeft: "10vw",
              paddingRight: "10vw",
              paddingBottom: "20px",
              fontFamily: "Raleway, sans-serif",
            }}
          >
            The mentorship can be provided for both early and advanced-career
            individuals. The only pre-requisite to the program is commitment.
            Spaces are limited so book your place today!
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Mentorship;
